import { render, staticRenderFns } from "./TabPressConference.vue?vue&type=template&id=bf5d2cc8&scoped=true"
import script from "./TabPressConference.vue?vue&type=script&lang=js"
export * from "./TabPressConference.vue?vue&type=script&lang=js"
import style0 from "./TabPressConference.vue?vue&type=style&index=0&id=bf5d2cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5d2cc8",
  null
  
)

export default component.exports